module.exports = __webpack_public_path__ + "img/rectangle-code.986a2ee5.svg";